import styled, { css } from "styled-components/macro";
import { hexToRgba } from "../../utils/common";
import React from "react";

const CardButtonRoot = styled.button<{ $selected: boolean }>`
  padding: 32px;
  background: white;
  cursor: pointer;

  ${(p) =>
    p.$selected
      ? css`
          border: 1px solid ${(p) => p.theme.colors.primary};
          background: ${(p) => hexToRgba(p.theme.colors.primary, 0.05)};
        `
      : css`
          border: 1px solid ${(p) => p.theme.colors.borderSecondary};
        `}
  border-radius: 8px;
`;
const CardButtonIconContainer = styled.div`
  img {
    height: 95px;
    width: auto;
    margin-bottom: 16px;
  }
`;
const CardButtonLabel = styled.div`
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
`;
const CardButtonDescription = styled.div`
  font-size: 14px;
  color: ${(p) => p.theme.colors.midGrey};
`;
export const CardButton = ({
  label,
  description,
  icon,
  onClick,
  selected,
  readonly
}: {
  label: string;
  description: string;
  icon: React.ReactNode;
  onClick: () => void;
  selected: boolean;
  readonly?: boolean;
}) => {
  return (
    <CardButtonRoot
      disabled={readonly}
      $selected={selected}
      onClick={() => onClick()}
    >
      <CardButtonIconContainer>{icon}</CardButtonIconContainer>
      <CardButtonLabel>{label}</CardButtonLabel>
      <CardButtonDescription>{description}</CardButtonDescription>
    </CardButtonRoot>
  );
};
